import React, { useState, useEffect } from 'react';
import Header from '../../components/Header';
import './index.css';
import Pagamentos from '../../components/Pagamentos';
import { useParams, useHistory } from "react-router-dom";
import { format } from 'date-fns-tz';
import api from '../../services/api_adiantamento';

export default function GestaoAdiantamentos() {

    const [adiantamento, setAdiantamento] = useState({});
    const [fornecedor, setFornecedor] = useState({});
    const [dadosBancarios, setDadosBancarios] = useState(null);
    const [pagamento, setPagamento] = useState([]);
    const [tiposDesconto, setTiposDesconto] = useState([]);
    const [usuario, setUsuario] = useState({});
    const [anexo, setAenxo] = useState({});

    let history = useHistory();
    let params = useParams();

    useEffect(() => {
        api.get(`/usuarios/getbytoken`).then(function (response) {
            if (response.data) {
                setUsuario(response.data);
            }
        }).catch(function (error) {
            // handle error
            console.log(error);
        }).then(function () {
            // always executed
        });
    }, [])

    useEffect(() => {
        if (params.id) {
            api.get(`/adiantamento/id/${params.id}`).then(function (response) {
                if (response.data) {
                    setAdiantamento(response.data.adiantamento);
                    if (response.data.anexo) {
                        setAenxo(response.data.anexo)
                    }
                }
            }).catch(function (error) {
                // handle error
                console.log(error);
            }).then(function () {
                // always executed
            });
        }
    }, [params.id]);

    useEffect(() => {
        api.get(`/tipodesconto`).then(function (response) {
            if (response.data) {
                setTiposDesconto(response.data);
            }
        }).catch(function (error) {
            // handle error
            console.log(error);
        }).then(function () {
            // always executed
        });
    }, []);

    useEffect(() => {
        if (adiantamento.fornecedor_id) {
            api.get(`/fornecedor/id/${adiantamento.fornecedor_id}/empresa_id/${adiantamento.fornecedor_empresa_id}/empresa_fornecedor/1`).then(function (response) {
                if (response.data) {
                    setFornecedor(response.data);
                    if (response.data.dados_bancarios.length > 0) {
                        setDadosBancarios(response.data.dados_bancarios);
                    }
                }
            }).catch(function (error) {
                // handle error
                console.log(error);
            }).then(function () {
                // always executed
            });
        }

    }, [adiantamento]);

    useEffect(() => {
        if (adiantamento.id) {
            api.get(`/pagamento/adiantamento/${adiantamento.id}`).then(function (response) {
                if (response.data) {
                    setPagamento(response.data);
                }
            }).catch(function (error) {
                // handle error
                console.log(error);
            }).then(function () {
                // always executed
            });
        }
    }, [adiantamento]);

    function handleClose(event) {
        event.preventDefault();
        history.push('/adiantamento');
    }

    function handleEncontramento() {
        history.push('/encontramento/' + adiantamento.id);
    }

    function handleAprove() {
        const data = { status: 1 };
        setAdiantamento(data);
        api.put(`/adiantamento/id/${adiantamento.id}`, data).then(function (response) {
            if (response.data) {
                history.push('/adiantamento');
            }
        }).catch(function (error) {
            // handle error
            console.log(error);
        }).then(function () {
            // always executed
        });
    }

    function handleCadastrar() {
        const data = { status: 6 };
        setAdiantamento(data);
        api.put(`/adiantamento/id/${adiantamento.id}`, data).then(function (response) {
            if (response.data) {
                history.push('/adiantamento');
            }
        }).catch(function (error) {
            // handle error
            console.log(error);
        }).then(function () {
            // always executed
        });
    }

    function handleReject() {
        const data = { status: 3 };
        setAdiantamento(data);
        api.put(`/adiantamento/id/${adiantamento.id}`, data).then(function (response) {
            if (response.data) {
                history.push('/adiantamento');
            }
        }).catch(function (error) {
            // handle error
            console.log(error);
        }).then(function () {
            // always executed
        });
    }

    function renderAutorizar() {
        if ((adiantamento.status < 1 || adiantamento.status == 3) && usuario && usuario.perfis) {
            var canRender = false;
            usuario.perfis.map((perfil) => {

                if (perfil.descricao === 'GESTOR' || perfil.descricao === 'ADMINISTRADOR') {
                    canRender = true;
                }
            })
            if (canRender) {
                return (
                    <input type="submit" value="AUTORIZAR" className="btn btn-success" onClick={handleAprove} />
                )
            }
        }
    }

    function renderRejeitar() {
        if (adiantamento.status < 1 && usuario && usuario.perfis) {
            var canRender = false;
            usuario.perfis.map((perfil) => {
                if (perfil.descricao === 'GESTOR' || perfil.descricao === 'ADMINISTRADOR') {
                    canRender = true;

                }
            })

            if (canRender) {
                return (
                    <input type="submit" value="REJEITAR" className="btn btn-danger" onClick={handleReject} />
                )
            }
        }
    }

    function renderTipoDesconto() {
        return (
            <div className="row">
                {tiposDesconto.map((tipodesconto) => {
                    return (
                        <div className="custom-control custom-radio col-md-4">
                            <input type="radio" key={`radiodesconto${tipodesconto.id}`} id="radiodesconto1" name="radiodesconto" className="custom-control-input" checked={tipodesconto.id === adiantamento.adi_tipo_desconto_id ? true : false} onChange={() => { }} />
                            <label className="custom-control-label" htmlFor={`radiodesconto${tipodesconto.id}`} >{tipodesconto.descricao}</label>
                        </div>
                    )
                })}
                <div className="col-md-4"></div>
                {adiantamento.adi_tipo_desconto_id === 2 ? (
                    <div className="col-md-4">
                        <label>percentual:</label>
                        <input type="text" id="percentual" value={adiantamento.percentual} className="form-control" onChange={() => { }}></input>
                    </div>
                ) : <div className="col-md-4"></div>}
                <div className="col-md-4"></div>
            </div>
        )
    }

    function renderRejeitado() {
        if (adiantamento.status === 3) {
            return (
                <div className="col-md-4 infos">
                    <label>Rejeitado por:&nbsp;</label>
                    <label>{adiantamento.rejeitado_por}&nbsp;em&nbsp;</label>
                    <label>{adiantamento.dt_rejeicao ? format(new Date(adiantamento.dt_rejeicao), 'dd/MM/yyyy', { timeZone: 'America/Sao_Paulo' }) : ''}</label>
                </div>
            )
        }
    }

    function renderAprovado() {
        if (adiantamento.status !== 0 && adiantamento.status !== 3) {
            return (
                <div className="col-md-4 infos">
                    <label>Liberado por:&nbsp;</label>
                    <label>{adiantamento.autorizado_por}&nbsp;em&nbsp;</label>
                    <label>{adiantamento.dt_liberacao ? format(new Date(adiantamento.dt_liberacao), 'dd/MM/yyyy', { timeZone: 'America/Sao_Paulo' }) : ''}</label>
                </div>
            )
        }
    }

    function renderDadosBancarios() {
        if (dadosBancarios) {
            return (
                <div className="row col-md-12 mb-1">
                    <h4 className="col-md-12">DADOS BANCARIOS</h4>
                    <div className="col-md-1">
                        <label>Número:</label>
                        <input type="text" id="num_banco" value={dadosBancarios.num_banco} className="form-control" onChange={() => { }}></input>
                    </div>
                    <div className="col-md-1">
                        <label>Agencia:</label>
                        <input type="text" id="agencia" value={dadosBancarios.agencia} className="form-control" onChange={() => { }}></input>
                    </div>
                    <div className="col-md-1">
                        <label>Conta:</label>
                        <input type="text" id="num_conta" value={dadosBancarios.conta} className="form-control" onChange={() => { }}></input>
                    </div>
                    <div className="col-md-1">
                        <label>Tipo:</label>
                        <input type="text" id="tipo_conta" value={dadosBancarios.tipo_conta} className="form-control" onChange={() => { }}></input>
                    </div>
                    <div className="col-md-1 mb-1">
                        <label>Operacao:</label>
                        <input type="text" id="operacao" value={dadosBancarios.operacao} className="form-control" onChange={() => { }}></input>
                    </div>
                    <div className="col-md-2">
                        <label>CPF/CNPJ:</label>
                        <input type="text" id="cpf_cnpj_favorecido" value={dadosBancarios.cpf_cnpj} className="form-control" onChange={() => { }}></input>
                    </div>
                    <div className="col-md-5">
                        <label>Favorecido:</label>
                        <input type="text" id="favorecido" value={dadosBancarios.favorecido} className="form-control" onChange={() => { }}></input>
                    </div>
                </div>
            )
        }
    }

    function renderEncontramento() {
        if ((adiantamento.status === 4 || adiantamento.status === 2) && usuario && usuario.perfis) {
            var canRender = false;
            usuario.perfis.map((perfil) => {
                if (perfil.descricao === 'FINANCEIRO' || perfil.descricao === 'ADMINISTRADOR') {
                    canRender = true;
                }
            })
            if (canRender) {
                return (
                    <input type="submit" value="ENCONTRO DE CONTAS" className="btn btn-warning" onClick={handleEncontramento} />
                )
            }
        }
    }

    function renderCadastrar() {
        if (adiantamento.status === 1 && usuario && usuario.perfis) {
            var canRender = false;
            usuario.perfis.map((perfil) => {
                if (perfil.descricao === 'FINANCEIRO' || perfil.descricao === 'ADMINISTRADOR') {
                    canRender = true;
                }
            })
            if (canRender) {
                return (
                    <input type="submit" value="CADASTRAR" className="btn btn-light" onClick={handleCadastrar} />
                )
            }
        }
    }

    function renderAnexo() {
        console.log('anexo aqui -----------', anexo)
        if (anexo.url && anexo.originalname) {
            return (
                <a href={anexo.url} target='_blank'>{anexo.originalname}</a>
            )
        } else {
            return (
                <spam>
                    Anexo não encontrado
                </spam>
            )
        }
    }
    return (
        <div className="container-lg">
            <Header title="GESTÃO DE ADIANTAMENTOS" />
            <div className="row col-md-12 mb-1">
                <div className="col-md-4 infos">
                    <label >Empresa:&nbsp;</label>
                    <label >{adiantamento.empresa ? adiantamento.empresa.descempresa : ''}</label>
                </div>
                <div className="col-md-4 infos">
                    <label>Solicitante:&nbsp;</label>
                    <label>{adiantamento.solicitante}</label>
                </div>
                {renderAprovado()}
                {renderRejeitado()}
            </div>
            <div className="col-md-12 mb-1">
                <div className=" row col-md-12 mb-1 border">
                    <div className="col-md-3 mb-1">
                        <label>Previsão de encerramento:</label>
                        <input
                            type="text"
                            id="previsao"
                            value={
                                adiantamento.previsao_encerramento ? format(new Date(adiantamento.previsao_encerramento), 'dd/MM/yyyy', { timeZone: 'America/Sao_Paulo' }) : null
                            }
                            className="form-control"
                            onChange={() => { }}>
                        </input>
                    </div>
                    <div className="col-md-3 mb-1">
                        <label>Número do Documento:</label>
                        <input type="text" id="num_doc" value={adiantamento.num_documento} className="form-control" onChange={() => { }}></input>
                    </div>
                    <div className="col-md-6">
                        <label>Documento: </label>
                        {renderAnexo()}
                    </div>
                    <div className="col-md-2">
                        <label>Cód. Fornecedor:</label>
                        <input type="text" id="cod_fornecedor" value={adiantamento.fornecedor_id} className="form-control" onChange={() => { }}></input>
                    </div>
                    <div className="col-md-2">
                        <label>CPF/CNPJ:</label>
                        <input type="text" id="cpf_cnpj" value={fornecedor.cpf_cnpj} className="form-control" onChange={() => { }}></input>
                    </div>
                    <div className="col-md-2">
                        <label>Tipo:</label>
                        <input type="text" id="tipo_fornecedor" value={fornecedor.tipo} className="form-control" onChange={() => { }}></input>
                    </div>
                    <div className="col-md-6">
                        <label>Nome:</label>
                        <input type="text" id="nome_fornecedor" value={fornecedor.descricao} className="form-control" onChange={() => { }}></input>
                    </div>
                    {renderDadosBancarios()}
                    <div className="col-md-12">
                        <h4>OBSERVAÇÃO</h4>
                        <p>{adiantamento.observacao}</p>
                    </div>
                    <div className="col-md-12 mb-1">
                        <h4>TIPO DE DESCONTO</h4>
                        {renderTipoDesconto()}
                    </div>
                </div>
                <div className=" row col-md-12 border">
                    <div className="col-md-12">
                        <h3>PAGAMENTOS</h3>
                        <Pagamentos pagamentos={pagamento} adiantamento={adiantamento} usuario={usuario}></Pagamentos>
                    </div>
                </div>
            </div>
            <div className=" row col-md-12">
                <div className="col-md-2">
                    {renderAutorizar()}
                </div>
                <div className="col-md-2">
                    {renderRejeitar()}
                </div>
                <div className="col-md-2">
                    {renderEncontramento()}
                </div>
                <div className="col-md-2">
                    {renderCadastrar()}
                </div>
                <div className="col-md-2">
                    <input type="submit" value="FECHAR" className="btn btn-dark" onClick={handleClose} />
                </div>
            </div>
        </div>
    )
}